const authFetch = (url, options) => fetch(url, { ...options, credentials: 'include' });

export default authFetch;
